module.exports = __webpack_public_path__ + "static/img/originality.88aeacd9.png";